const selectors = {
  COMPOSITE_GROUP: 'ws-composite-group',
  COMPOSITE_ITEM: 'ws-composite-item',
  MEDIA_CONTAINER: 'ws-media-container',
};

export default selectors;
